/**
 * Les icônes — §4, décision 3 de la conception L10.
 *
 * Des SVG, jamais des emoji. Un emoji se rend différemment sur chaque plateforme, se fait lire
 * à voix haute par les lecteurs d'écran, et ne se colore pas : trois raisons dont chacune
 * suffirait. Les tracés sont écrits ici, à la main, en 24×24 et contour 1,75 — aucune
 * dépendance à installer, aucune licence à ré-auditer à chaque montée de version.
 *
 * Un seul sprite est posé au montage de l'application ; chaque `<Icone>` ne rend qu'un `<use>`.
 * Le poids est donc payé une fois, quel que soit le nombre d'icônes à l'écran.
 */

const TRACES = {
  loupe: '<circle cx="11" cy="11" r="7"/><path d="M20.5 20.5 16.7 16.7"/>',
  coeur:
    '<path d="M12 20.6s-7.6-4.7-7.6-10.1A4.6 4.6 0 0 1 12 8a4.6 4.6 0 0 1 7.6 2.5c0 5.4-7.6 10.1-7.6 10.1z"/>',
  cloche:
    '<path d="M18 8.5a6 6 0 1 0-12 0c0 6.5-2.5 7.5-2.5 7.5h17S18 15 18 8.5z"/><path d="M13.7 19.5a2 2 0 0 1-3.4 0"/>',
  message:
    '<path d="M20.5 11.5a8 8 0 0 1-8.5 8 9 9 0 0 1-3.8-.9L3.5 20l1.8-4.7a8 8 0 0 1-1.8-5A8 8 0 0 1 12 3.5a8 8 0 0 1 8.5 8z"/>',
  utilisateur: '<circle cx="12" cy="8" r="3.6"/><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/>',
  groupe:
    '<circle cx="9" cy="8" r="3.4"/><path d="M2.5 20.5a6.5 6.5 0 0 1 13 0"/><path d="M16.5 5.6a3.4 3.4 0 0 1 0 6.8"/><path d="M17.5 20.5h4a5.6 5.6 0 0 0-3.7-5.3"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  maison: '<path d="M3.5 10.7 12 3.5l8.5 7.2V19a1.5 1.5 0 0 1-1.5 1.5h-4v-6h-6v6h-4A1.5 1.5 0 0 1 3.5 19z"/>',
  carte:
    '<path d="M19.5 10.2c0 5.6-7.5 10.8-7.5 10.8s-7.5-5.2-7.5-10.8a7.5 7.5 0 0 1 15 0z"/><circle cx="12" cy="10" r="2.8"/>',
  calendrier:
    '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 9.5h17M8 3.5V6M16 3.5V6"/>',
  fichier:
    '<path d="M13.5 3.5H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V8.5z"/><path d="M13.5 3.5v5h5"/><path d="M8.5 13h7M8.5 16.5h4.5"/>',
  monnaie: '<rect x="3.5" y="5.5" width="17" height="13" rx="2"/><path d="M16 12h4.5"/><path d="M3.5 9.5h17"/>',
  etoile: '<path d="M12 3.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"/>',
  chevron: '<path d="M9.5 5.5 16 12l-6.5 6.5"/>',
  chevronBas: '<path d="M5.5 9 12 15.5 18.5 9"/>',
  croix: '<path d="M6 6l12 12M18 6 6 18"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  verifie:
    '<path d="M12 3.2l2.1 1.6 2.6-.3 1 2.4 2.4 1.2-.6 2.6.6 2.6-2.4 1.2-1 2.4-2.6-.3L12 20.8l-2.1-1.6-2.6.3-1-2.4-2.4-1.2.6-2.6-.6-2.6 2.4-1.2 1-2.4 2.6.3z"/><path d="M9 12.3l2.2 2.2 4-4.6"/>',
  appareil:
    '<path d="M3.5 8.5h3.2l1.5-2.2h7.6l1.5 2.2h3.2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z"/><circle cx="12" cy="13.5" r="3.4"/>',
  filtre:
    '<path d="M4 7h10M18 7h2M4 12h4M12 12h8M4 17h8M16 17h4"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="14" cy="17" r="2"/>',
  tri: '<path d="M7 4.5v15M4 7.5l3-3 3 3M17 19.5v-15M14 16.5l3 3 3-3"/>',
  cle: '<circle cx="8" cy="15" r="3.6"/><path d="M10.6 12.4 19 4l2.5 2.5-2 2-2-2-2 2"/>',
  coche: '<path d="M5 12.5 9.5 17 19 7"/>',
  oeil: '<path d="M2.5 12S6 6.5 12 6.5 21.5 12 21.5 12 18 17.5 12 17.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  telechargement: '<path d="M12 4v11M8 11.5l4 4 4-4M5 20h14"/>',
  envoyer: '<path d="M21 3 10.5 13.5"/><path d="M21 3l-6.8 18-3.7-8.3L3 9z"/>',
  horloge: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7v5.2l3.2 2"/>',
  alerte: '<path d="M12 4.2 21 20H3z"/><path d="M12 10v4.3M12 17.2v.6"/>',
  info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.2M12 7.8v.6"/>',
  poubelle: '<path d="M4 7h16M9.5 7V4.8h5V7M6.5 7l1 13h9l1-13"/>',
  crayon: '<path d="M4 20h4L19 9l-4-4L4 16z"/>',
  sortie:
    '<path d="M10 4H6.5A1.5 1.5 0 0 0 5 5.5v13A1.5 1.5 0 0 0 6.5 20H10"/><path d="M16 8.5 19.5 12 16 15.5M19.5 12H10"/>',
  globe:
    '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5a13 13 0 0 1 0 17 13 13 0 0 1 0-17z"/>',
  reglages:
    '<circle cx="12" cy="12" r="3"/><path d="M12 3.5v2.2M12 18.3v2.2M20.5 12h-2.2M5.7 12H3.5M18 6l-1.6 1.6M7.6 16.4 6 18M18 18l-1.6-1.6M7.6 7.6 6 6"/>',
  livre: '<path d="M5 5.5A1.5 1.5 0 0 1 6.5 4H19v14.5H6.5A1.5 1.5 0 0 0 5 20z"/><path d="M5 18.5h14"/>',
  drapeau: '<path d="M6 21V4h12l-2.4 4.2L18 12.5H6"/>',
  rafraichir: '<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20.5 4v5h-5"/>',
  signet: '<path d="M6.5 4.5h11v16l-5.5-4.3-5.5 4.3z"/>',
  image:
    '<rect x="3.5" y="5" width="17" height="14" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M4 17l4.5-4.5 3.5 3.5 3-3 5 5"/>',
  telephone:
    '<path d="M6 3.5h3.6l1.7 4.3-2.2 1.4a12.5 12.5 0 0 0 5.7 5.7l1.4-2.2 4.3 1.7V18a2.5 2.5 0 0 1-2.5 2.5A16.5 16.5 0 0 1 3.5 6 2.5 2.5 0 0 1 6 3.5z"/>',
  panier:
    '<path d="M3.5 8h17l-1.6 11.5a1 1 0 0 1-1 .9H6.1a1 1 0 0 1-1-.9z"/><path d="M8.5 8V6a3.5 3.5 0 0 1 7 0v2"/>',
  bouclier:
    '<path d="M12 3.2l8 2.8v6c0 5.2-4.2 8.2-8 9.3-3.8-1.1-8-4.1-8-9.3V6z"/><path d="M9 12.3l2.2 2.2 4-4.6"/>',
  boite:
    '<path d="M4 13h4.2l1.6 2.6h4.4L15.8 13H20"/><path d="M4 13 6.4 5h11.2L20 13v6.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/>',
  balance: '<path d="M12 4v16M7 20h10M4 9h16M6.5 9 4 14.5h5zM17.5 9 15 14.5h5z"/>',
  tache: '<rect x="4" y="4.5" width="16" height="15.5" rx="2"/><path d="M8.5 12.3l2.4 2.4 4.6-5"/>',
  export: '<path d="M12 15V4M8.5 7.5 12 4l3.5 3.5"/><path d="M5 14v5.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V14"/>',
  soleil:
    '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/>',
  lune: '<path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/>',

  /*
   * Les sept équipements — ticket `fo-annonce-09`.
   *
   * Ils étaient tous rendus par la même coche : sept lignes identiques dont seul le libellé
   * changeait, ce qui oblige à LIRE la liste au lieu de la balayer. Un pictogramme par nature rend
   * « il y a une machine à laver » repérable sans lecture, et c'est tout ce qu'on demande à cette
   * section.
   *
   * Même grille que les autres : 24 × 24, contour 1,75, aucun aplat. Un jeu d'icônes dont la
   * moitié vient d'une autre main se voit immédiatement.
   */
  wifi: '<path d="M2.5 9a13.5 13.5 0 0 1 19 0"/><path d="M6 12.5a8.5 8.5 0 0 1 12 0"/><path d="M9.5 16a3.5 3.5 0 0 1 5 0"/><path d="M12 19.5v.01"/>',
  chauffeEau: '<rect x="6" y="3.5" width="12" height="13" rx="2"/><path d="M9.5 16.5v4M14.5 16.5v4"/><path d="M9.5 7.5h5"/><path d="M12 10.5v3"/>',
  machineALaver: '<rect x="4" y="3.5" width="16" height="17" rx="2"/><circle cx="12" cy="13" r="4.5"/><path d="M7.5 7h2M14 7h2.5"/>',
  cuisine: '<path d="M6 3.5v7a2 2 0 0 0 4 0v-7"/><path d="M8 10.5v10"/><path d="M16.5 3.5c-1.5 1.5-2 3-2 5s.5 2.5 2 2.5 2-.5 2-2.5-.5-3.5-2-5z"/><path d="M16.5 11v9.5"/>',
  parking: '<rect x="3.5" y="3.5" width="17" height="17" rx="3"/><path d="M9.5 17V7h3.2a3 3 0 0 1 0 6H9.5"/>',
  concierge: '<circle cx="12" cy="6" r="2.6"/><path d="M4.5 17.5a7.5 7.5 0 0 1 15 0"/><path d="M3 17.5h18"/><path d="M8 20.5h8"/>',
  climatisation: '<rect x="3.5" y="4.5" width="17" height="7" rx="2"/><path d="M7 8h10"/><path d="M7.5 14.5c0 1.5 1 2 1 3.5M12 14.5c0 1.5 1 2 1 3.5M16.5 14.5c0 1.5 1 2 1 3.5"/>',
} as const

export type NomIcone = keyof typeof TRACES

/**
 * Le sprite, posé une seule fois à la racine de l'application.
 *
 * `dangerouslySetInnerHTML` est ici sans danger au sens propre : la chaîne est une constante du
 * module, jamais une donnée. C'est le seul moyen de déclarer des `<symbol>` sans écrire quarante
 * composants.
 */
export function SpriteIcones() {
  const symboles = Object.entries(TRACES)
    .map(([nom, trace]) => `<symbol id="i-${nom}" viewBox="0 0 24 24">${trace}</symbol>`)
    .join('')

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'none' }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: symboles }}
    />
  )
}

/**
 * Une icône.
 *
 * `miroir` retourne le tracé en arabe — et il est **explicite**, pas automatique : une flèche se
 * retourne, une horloge non. Un miroir global aurait l'air correct sur la moitié des icônes.
 *
 * Sans `titre`, l'icône est décorative : elle est masquée aux lecteurs d'écran, parce que le
 * texte à côté dit déjà la même chose. Avec `titre`, elle porte le sens à elle seule.
 */
export function Icone({
  nom,
  taille,
  miroir,
  arriere,
  titre,
}: {
  nom: NomIcone
  taille?: 'sm' | 'lg'
  /** Retourne le trace en arabe. Explicite : une fleche se retourne, une horloge non. */
  miroir?: boolean
  /** Pointe vers le RETOUR : a gauche en francais, a droite en arabe. */
  arriere?: boolean
  titre?: string
}) {
  const classes = [
    'icone',
    taille === 'sm' ? 'icone--sm' : '',
    taille === 'lg' ? 'icone--lg' : '',
    miroir === true ? 'icone--miroir' : '',
    arriere === true ? 'icone--arriere' : '',
  ]
    .filter((classe) => classe !== '')
    .join(' ')

  return (
    <svg className={classes} aria-hidden={titre === undefined} role={titre === undefined ? undefined : 'img'}>
      {titre !== undefined && <title>{titre}</title>}
      <use href={`#i-${nom}`} />
    </svg>
  )
}
